/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Heater } from "./modelHeater";

class ControllerHeater extends ControllerModel {
  constructor() {
    super("ControllerHeater");
    
    this.setNewNode = (callback) => {
      let _heater = new Heater();
      _heater.decorate(callback);

      this.addNode(_heater);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let _heater = new Heater();
      _heater.copyFrom(node);
      _heater.decorate(callback);
      this.addNode(_heater)
    }

    this.getProperties = async (node) => {
      let n = new Heater();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Heater();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerHeater };
